var map = {
	"./avatar": 117,
	"./avatar.jpg": 117,
	"./bg-auth": 118,
	"./bg-auth.jpg": 118,
	"./bg-pattern": 119,
	"./bg-pattern-light": 120,
	"./bg-pattern-light.svg": 120,
	"./bg-pattern.png": 119,
	"./waves": 121,
	"./waves.png": 121
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 125;